import React from "react";

const STATUS_COLOR_CLASS = {
  active: "success-status",
  inactive: "gray-status",
  pending: "warning-status"
};

const SERVICE_STATUS = {
  active: "ACTIVE",
  inactive: 'INACTIVE',
  pending: 'PENDING',
};

const CUSTOMER_TYPE = {
  residential: "Residential",
  commercial: 'Commercial'
};

class DataTable {

    customerColumns = () => {
      return ([
        {
          title: 'Customer',
          dataIndex: 'last_name',
          key: 'last_name',
          sorter: true,
          render: (text, record) => <span>{record?.last_name} {record?.first_name}</span>
        },
        {
          title: 'Customer Type',
          dataIndex: 'user_roles__name',
          key: 'user_roles__name',
          sorter: true,
          render: (text, record) => (<span>{CUSTOMER_TYPE[record?.customer_type] || ''}</span>)
        },
        {
          title: 'Active Services',
          dataIndex: 'active_services',
          key: 'active_services',
          sorter: true,
          render: (text, record) => (<span>{record?.active_services || '0'}</span>)
        },
        {
          title: 'status',
          dataIndex: 'status',
          key: 'status',
          sorter: false,
          render: (text, record) => (<span className={`status ${STATUS_COLOR_CLASS[record.status]}`}>{record.status ? SERVICE_STATUS[record.status]: ''}</span>)
        }
      ]);
    }
}
export default new DataTable();